import React from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

import { Text } from 'components';
import { useDispatch, useSelector } from 'react-redux';
import {
  sideBarInfoSelector,
  updateSideBarInfoField,
} from 'redux/slices/sideBar/sideBarSlice';

const SideItem = ({ title, icon, route, subItems, contain, field }) => {
  const navigate = useNavigate();
  const sideBarInfo = useSelector(sideBarInfoSelector);
  const dispatch = useDispatch();
  const handleNavigate = (route) => {
    navigate(route);
  };

  const handleOpen = () => {
    dispatch(updateSideBarInfoField({ value: !sideBarInfo[field], field }));
  };

  return (
    <div className="relative">
      <button
        onClick={subItems.length > 0 ? handleOpen : () => handleNavigate(route)}
        className={`flex flex-row items-center px-4 py-2 mt-5 text-ink-light w-full transition-colors duration-200 transform rounded-md dark:text-ink-light hover:bg-sky ${
          window.location.pathname === route
            ? 'bg-sky'
            : subItems.find((si) => si.route === window.location.pathname) ||
              window.location.pathname.includes(contain)
            ? 'bg-sky'
            : ''
        }`}
      >
        {React.isValidElement(icon) ? (
          icon
        ) : (
          <img src={icon} alt="" className="w-5 h-5" />
        )}
        <Text weight="semibold" variant="ink" className="ml-2">
          {title}
        </Text>
      </button>
      {subItems.length > 0 && (
        <div
          className={`p-2 ${
            sideBarInfo[field] ? 'block' : 'hidden'
          } flex flex-col rounded-md mt-1`}
        >
          {subItems.map((item) => {
            return (
              <button
                key={item.title}
                onClick={() => handleNavigate(item.route)}
                className={`items-center p-4 text-ink-light w-full transition-colors text-left duration-200 transform  rounded-md dark:text-ink-light hover:bg-sky ${
                  window.location.pathname === item.route ? 'bg-sky' : ''
                }`}
              >
                <Text weight="normal" variant="ink">
                  {item.title}
                </Text>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default SideItem;

SideItem.propTypes = {
  title: PropTypes.string,
  field: PropTypes.string,
  route: PropTypes.string,
  contain: PropTypes.string,
  icon: PropTypes.any,
  subItems: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      route: PropTypes.string,
    })
  ),
};
